import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v.5m0 3v1.5m0 3v6","key":"svg-0"}],["path",{"d":"M18 13l-6 6","key":"svg-1"}],["path",{"d":"M6 13l6 6","key":"svg-2"}]]

/**
 * IconArrowDownDashed
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZG93bi1kYXNoZWQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDV2LjVtMCAzdjEuNW0wIDN2NiIgLz4KICA8cGF0aCBkPSJNMTggMTNsLTYgNiIgLz4KICA8cGF0aCBkPSJNNiAxM2w2IDYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-down-dashed
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowDownDashed = createReactComponent('outline', 'arrow-down-dashed', 'ArrowDownDashed', __iconNode);

export default IconArrowDownDashed;